/**
 * @generated SignedSource<<5e566424cc94d6f7ee1031c41277f2a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NewIssueTimelineSecondary$data = {
  readonly isTransferInProgress: boolean;
  readonly " $fragmentType": "NewIssueTimelineSecondary";
};
export type NewIssueTimelineSecondary$key = {
  readonly " $data"?: NewIssueTimelineSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewIssueTimelineSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewIssueTimelineSecondary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTransferInProgress",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "eb0f80821d812b64dd865607ed4c1447";

export default node;
